import { render, staticRenderFns } from "./AffiliatePage.vue?vue&type=template&id=b151072c&"
import script from "./AffiliatePage.vue?vue&type=script&lang=js&"
export * from "./AffiliatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b151072c', component.options)
    } else {
      api.reload('b151072c', component.options)
    }
    module.hot.accept("./AffiliatePage.vue?vue&type=template&id=b151072c&", function () {
      api.rerender('b151072c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/AffiliatePage.vue"
export default component.exports